module.exports = __webpack_public_path__ + "static/media/RedLightText.fd942d5e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/rlgl/Logo/svg/RedLightText.svg
// module id = 424
// module chunks = 0